import PostSneakPeeks from './PostSneakPeeks';

export default PostSneakPeeks;
